import { Component } from '@angular/core'

@Component({
  selector: 'flowaccount-business-registration-ads-9-company',
  templateUrl: './business-registration-ads-9-company.component.html',
  styleUrl: './business-registration-ads-9-company.component.scss',
})
export class BusinessRegistrationAds9CompanyComponent {
  loopArray(no: number) {
    return new Array(no)
  }
}
